import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const THRESHOLD = 80;

export const PullToRefresh = () => {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(null);
  const pulling = useRef(false);

  useEffect(() => {
    const onStart = (e) => {
      if (window.scrollY <= 0 && e.touches.length === 1) {
        startY.current = e.touches[0].clientY;
        pulling.current = true;
      }
    };
    const onMove = (e) => {
      if (!pulling.current || startY.current === null) return;
      if (window.scrollY > 0) { pulling.current = false; setPull(0); return; }
      const delta = e.touches[0].clientY - startY.current;
      setPull(delta > 0 ? Math.min(delta * 0.45, 130) : 0);
    };
    const onEnd = () => {
      if (!pulling.current) return;
      pulling.current = false;
      startY.current = null;
      setPull((p) => {
        if (p >= THRESHOLD) {
          setRefreshing(true);
          setTimeout(() => window.location.reload(), 150);
          return THRESHOLD;
        }
        return 0;
      });
    };
    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchmove", onMove, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onEnd);
    };
  }, []);

  if (pull <= 0 && !refreshing) return null;
  const ready = pull >= THRESHOLD;
  return (
    <div data-testid="pull-to-refresh-indicator" className="fixed left-0 right-0 top-0 z-[60] flex justify-center pointer-events-none"
      style={{ transform: `translateY(${Math.max(pull - 44, 8)}px)`, transition: pulling.current ? "none" : "transform 0.2s" }}>
      <div className={`flex items-center gap-2 px-4 py-2 border text-[10px] font-bold uppercase tracking-widest bg-black/90 backdrop-blur-md ${
        ready || refreshing ? "border-pb-red text-pb-red" : "border-pb-border text-zinc-400"}`}>
        <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`}
          style={refreshing ? undefined : { transform: `rotate(${Math.min(pull / THRESHOLD, 1) * 270}deg)` }} />
        {refreshing ? "Refreshing…" : ready ? "Release to refresh" : "Pull to refresh"}
      </div>
    </div>
  );
};
